import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cn } from "@/lib/utils";
function Input(t0) {
  const $ = _c(10);
  let className;
  let props;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = type;
  } else {
    className = $[1];
    props = $[2];
    type = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== t1 || $[8] !== type) {
    t2 = <input type={type} data-slot="input" className={t1} {...props} />;
    $[6] = props;
    $[7] = t1;
    $[8] = type;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export { Input };